import {APIClient} from '../backend/ApiClient';

export const useGetThumbnailUrl = () => {
    const apiClient = APIClient();

    return (thumbnailUrl: string) => {
        return apiClient.downloadThumbnailUrl(thumbnailUrl).then((data) => data.token);
    };
};
